export const Events = {
  ADD_ITEM: 'px.headerCart.add',
  REMOVE_ITEM: 'px.headerCart.remove',
  ENABLE: 'px.headerCart.enable',
  PROPS: 'px.headerCart.props'
};

export const PeriodUnits = {
  ONE_TIME: 'ONE_TIME'
};

export const MarketConstants = {
  COOKIE_KEY: 'market',
  DEFAULT_MARKET_KEY: 'en'
};

export const CurrencyConstants = {
  COOKIE_KEY: 'currency',
  DEFAULT_CURRENCY_KEY: 'USD'
};
